import styled from "styled-components";
import colorPalette from "@streeteasy/design-system/deprecated/colors";
import FontAwesomeIcon from "@streeteasy/design-system/deprecated/Icons/FontAwesomeIcon";

export const LoadingIcon = styled(FontAwesomeIcon).attrs({
  iconClass: "spinner"
})`
  animation: spin 2s infinite linear;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(359deg);
    }
  }

  left: 50%;
  font-size: ${props => (props.size === "small" ? "14px" : "50px")};
  margin: auto;
  position: inherit;
  color: ${colorPalette.koalaGrey};
`;

LoadingIcon.displayName = "LoadingIcon";

export const Loading = styled.div`
  align-items: center;
  display: flex;
  justify-items: center;
  padding: ${props => (props.size === "small" ? "0" : "30px")};
  width: 100%;
`;

Loading.displayName = "Loading";
